import React from "react"
import badge from "badges/homo-sapiens-sapiens-plus.svg"
import { BadgeImage } from "backpack/badges/styled"

const HomoSapiensSapiensPlus = props => <BadgeImage src={badge} {...props} />

export default HomoSapiensSapiensPlus
